import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <CartProvider>
                    <App />
                    <Toaster
                        position="top-center"
                        theme="dark"
                        richColors
                        closeButton
                        toastOptions={{
                            style: {
                                background: "#0a0a0a",
                                color: "#f2ece0",
                                border: "1px solid rgba(212,188,124,0.35)",
                                fontFamily: "Montserrat, sans-serif",
                                borderRadius: 0,
                                letterSpacing: "0.02em",
                            },
                        }}
                    />
                </CartProvider>
            </AuthProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
